<template>
  <div :class="{ [backgroundClass]: $slots.default }" class="blank">
    <div v-if="$slots.title" class="blank__title sf-pv">
      <div class="sf-cg">
        <slot name="title"/>
      </div>
    </div>
    <div v-if="$slots.top" class="blank__top sf-pv">
      <div class="sf-cg">
        <slot name="top"/>
      </div>
    </div>
    <div v-if="$slots.default" class="blank__inner sf-cg sf-pv">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlankLayout',
  props: {
    backgroundClass: {
      type: String,
      default: 'sf-bg-page-bg',
    },
  },
};
</script>

<style lang="scss" scoped>
.blank {
  display: flex;
  flex-direction: column;

  &__title,
  &__top {
    border-top: 1px solid map-get($map: $colors, $key: border);
    background: #fff;
  }

  &__inner {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }
}
</style>
